import React from 'react';
import './noqrView.css';
import noQrImg from './../assets/img/icon/qrCodeError.png';
import logo from '../assets/logo_text.png';
import playStoreLogo from '../assets/img/icon/playStore.png';
import appStoreLogo from '../assets/img/icon/appleStore.png';
import { translateUiText } from '../i18n';

function NoQrView({ title, message, reason, locale = 'en' }) {
    // Default messages based on error reason
    const defaultTitle = reason === 'disabled'
        ? translateUiText(locale, 'qrDisabledTitle')
        : reason === 'expired'
        ? translateUiText(locale, 'qrExpiredTitle')
        : reason === 'session_expired'
        ? translateUiText(locale, 'accessExpiredTitle')
        : reason === 'not_found'
        ? translateUiText(locale, 'qrNotAvailableTitle')
        : reason === 'no_card'
        ? translateUiText(locale, 'cardNotLinkedTitle')
        : reason === 'data_error'
        ? translateUiText(locale, 'dataLoadingErrorTitle')
        : reason === 'api_error'
        ? translateUiText(locale, 'serviceUnavailableTitle')
        : translateUiText(locale, 'qrNotAvailableTitle');

    const defaultMessage = reason === 'disabled'
        ? translateUiText(locale, 'qrDisabledMessage')
        : reason === 'expired'
        ? translateUiText(locale, 'qrExpiredMessage')
        : reason === 'session_expired'
        ? translateUiText(locale, 'accessExpiredMessage')
        : reason === 'not_found'
        ? translateUiText(locale, 'qrNotAvailableMessage')
        : reason === 'no_card'
        ? translateUiText(locale, 'noCardMessage')
        : reason === 'data_error'
        ? translateUiText(locale, 'dataLoadingErrorMessage')
        : reason === 'api_error'
        ? translateUiText(locale, 'serviceUnavailableMessage')
        : translateUiText(locale, 'qrInvalidMessage');

    return (
        <div className='noqr-page'>
            <div className='noqr-card'>
                {/* Error content */}
                <div className='noqr-content'>
                    <img className="noqr-icon" src={noQrImg} alt={translateUiText(locale, 'qrErrorAlt')} />
                    <h2 className='noqr-title'>{title || defaultTitle}</h2>
                    <p className='noqr-message'>
                        {message || defaultMessage}
                    </p>
                </div>

                {/* Footer with logo and app links */}
                <div className="noqr-footer">
                    <div className="noqr-footer-content">
                        <img src={logo} alt={translateUiText(locale, 'foodAllergyCardAlt')} className="noqr-footer-logo" />
                        <div className="noqr-footer-download">
                            <p>{translateUiText(locale, 'downloadApp')}</p>
                            <a href="https://play.google.com/store/apps/details?id=com.foodallergycard" target="_blank" rel="noopener noreferrer">
                                <img src={playStoreLogo} alt={translateUiText(locale, 'playStoreAlt')} className="noqr-footer-store" />
                            </a>
                            <a href="https://apps.apple.com/app/food-allergy-card/id6448350429" target="_blank" rel="noopener noreferrer">
                                <img src={appStoreLogo} alt={translateUiText(locale, 'appStoreAlt')} className="noqr-footer-store" />
                            </a>
                        </div>
                    </div>
                    <p className="noqr-footer-copyright">&copy; {new Date().getFullYear()} Food Allergy Card. {translateUiText(locale, 'allRightsReserved')}</p>
                </div>
            </div>
        </div>
    );
}

export default NoQrView;
